import React, { useEffect } from 'react';
import Recorder from './index';

const RecorderDemo = () => {
  useEffect(() => {
    const recorder = new Recorder({
      apiKey: 'your-api-key',
      teamId: '64202e4d570c0f52f4c05133',
      folderId: '183f22f2-6ada-4d28-8412-a3e16ee6ea6b',
    });
    recorder.initialize();
  }, []);

  return <div id="screenapp-recorder" />;
};

export default RecorderDemo;
